import Component from '../abstracts/Component';
import 'bootstrap'; //TODO: import single component
import {
  toggleTabIndex
} from "../utils/FocusableElementUtils";

export default class TabsComponent extends Component {

  get SELECTORS() {
    return {
      main: '[data-tabs]',
      tabs: '[data-toggle="tab"]'
    };
  }

  get CLASSES() {
    return {
      show: 'show'
    };
  }

  constructor() {
    super();

    this.mainTarget = $(this.SELECTORS.main);

  }

  initTabs() {
    let ctx = this;

    this.$one('click.tab', ({
      event
    }) => {
      event.preventDefault();

      $('[data-tabs]').tab();
      $(event.target).tab('show');
      this.log('Tab initialized');

    }, this.SELECTORS.tabs)

    $(this.SELECTORS.tabs).on('shown.bs.tab', (event) => {
      var subMenu = $(event.target).parent().parent().parent().find('.tab-content > .sub-menu-component');
      subMenu.each((index, element) => {
        if (element.classList.contains('active')) {
          toggleTabIndex(element, true);
        } else {
          toggleTabIndex(element, false);
        }
      });
    });
  }

  bindEvents() {
    this.initTabs();
  }

  render() {
    this.bindEvents();
  }
}